/**
 * Lib.Common: v-visible directive
 *
 * @file
 * Alternative to `v-show` that manipulates `visibility` instead of `display`.
 *
 * @value {boolean} - If `false`, apply `visibility:hidden` to this element's CSS.
 */


export default {
    name: 'visible',
    directive: (el, binding) => {
        el.style.visibility = binding.value ? 'visible' : 'hidden';
    }
};
